import ProjectPresetsCollection from './ProjectPresetsCollection';

export default ProjectPresetsCollection;
